import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ResourcePlaceholder = _resolveComponent("ResourcePlaceholder");
    const _component_ElementPlaceholder = _resolveComponent("ElementPlaceholder");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass([
            'node-container',
            _ctx.rowTypeClass,
            _ctx.blockWidthClass,
            {
                'parent-first-child': _ctx.parentFirstChild,
                'parent-last-child': _ctx.parentLastChild,
            },
        ])
    }, {
        default: _withCtx(() => [
            (_ctx.isResourcePlaceholder)
                ? (_openBlock(), _createBlock(_component_ResourcePlaceholder, {
                    key: 0,
                    node: _ctx.node,
                    placeholder: _ctx.placeholder
                }, null, 8, ["node", "placeholder"]))
                : (_openBlock(), _createBlock(_component_ElementPlaceholder, {
                    key: 1,
                    node: _ctx.node
                }, null, 8, ["node"]))
        ]),
        _: 1
    }, 8, ["class"]));
}
